import Logo from "~/assets/global/logo";
import { Heading1 } from "~/components/typographies/Headings";
import { Text2 } from "~/components/typographies/Texts";
import ResponsiveIK from "./ResponsiveIK";
export default function GlobalSectionHero() {
  return (
    <>
      <section className={`  flex flex-col lg:flex-row items-center`}>
        <div className="mt-[5rem] lg:mt-[0rem] hero-container">
          {/* <img
            src="https://ik.imagekit.io/didigi/didigi/JASA-RENOVASI-bangunrumahkita/jasa-bangun-rumah-di-bekasi_hero-kecil.webp?tr=w-800"
            srcSet="
    https://ik.imagekit.io/didigi/didigi/JASA-RENOVASI-bangunrumahkita/jasa-bangun-rumah-di-bekasi_hero-kecil.webp 400w,
    https://ik.imagekit.io/didigi/didigi/JASA-RENOVASI-bangunrumahkita/jasa-bangun-rumah-di-bekasi_hero-kecil.webp?tr=w-800 800w,
    https://ik.imagekit.io/didigi/didigi/JASA-RENOVASI-bangunrumahkita/jasa-bangun-rumah-di-bekasi_hero.webp?tr=w-1200 1200w
  "
            sizes="(max-width: 600px) 400px, (max-width: 1024px) 800px, 1200px"
            width="800"
            height="800"
            loading="eager"
            decoding="async"
            alt="jasa bangun rumah di bekasi"
            className="w-full h-auto object-cover"
            {...({
              fetchpriority: "high",
            } as React.ImgHTMLAttributes<HTMLImageElement>)}
            fetchpriority="high"
          /> */}
          <ResponsiveIK
            src="https://ik.imagekit.io/didigi/didigi/JASA-RENOVASI-bangunrumahkita/jasa-bangun-rumah-di-bekasi_hero-kecil.webp"
            alt="jasa bangun rumah di bekasi"
            displayWidth={800} // tampilan real di fold; PSI bilang ~380×376 → pakai 400/800 kalau memang sekecil itu
            displayHeight={800}
            widths={[400, 800, 1200]}
            sizes="(max-width:600px) 400px, (max-width:1024px) 800px, 800px"
            loading="eager"
            priority="high"
          />
        </div>
        <div className="animate-fade-slide-up min-h-[300px] w-full lg:w-[50%] px-[1rem] lg:px-[2rem] flex flex-col gap-2 text-start">
          <Logo className="max-w-[10rem] lg:max-w-[15rem] pt-[2rem] " />
          <Heading1
            className="typo-light-primary"
            text={"Jasa Bangun Rumah Di Bekasi"}
          />
          {/* <HomeCompoTyping /> */}
          <Text2
            className="typo-light-primary text-start"
            text="Serahkan pembangunan rumah dan renovasi Anda kepada kami, jasa bangun rumah di Bekasi yang terpercaya dan berpengalaman. Kami siap membantu mewujudkan rumah impian Anda dengan kualitas terbaik dan harga yang kompetitif."
          />

          <div className="flex min-w-full">{/* <HomeCompoQuickProof /> */}</div>
        </div>
      </section>
    </>
  );
}
